import { render } from "./CardStatus.vue?vue&type=template&id=3612ff39"
import script from "./CardStatus.vue?vue&type=script&lang=js"
export * from "./CardStatus.vue?vue&type=script&lang=js"

import "./CardStatus.vue?vue&type=style&index=0&id=3612ff39&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__